<template>
  <div>
    <div class="d-flex align-items-center">
      <base-icon :icon="icon" :img="img" bg="black"></base-icon>
      <h5 class="m-0 fw-bold ms-3">{{title}}</h5>
      
      <button type="button" class="btn p-0 menu-toggle-chart ms-auto">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>
    <div class="row">
      <div class="col-8">
        <slot />
      </div>
      <div class="col-4 text-end">
        <img :src="require(`@/assets/img/dashboard/${iconChart}`)" class="me-4" />
      </div>
    </div>
  </div>
</template>

<script>
  import BaseIcon from '@/components/BaseIcon'
  export default {
    components: {
      BaseIcon
    },
    props: {
      icon: String,
      img: String,
      bgIcon: String,
      title: String,
      iconChart: {
        type: String,
        default : 'chart.svg'
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>